import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';
import { ChannelFeedInfoItem } from './channel-feed-info-item.model';
import { UserFeedInfoItem } from './user-feed-info-item.model';

export const FEED_INFO = Object.freeze({
  CHANNEL: ChannelFeedInfoItem,
  USER: UserFeedInfoItem,
  API_KEY: '',
});
export const RECORD = generateSchema(FEED_INFO);
export const KEYS: any = generateKeys(FEED_INFO);

export class FeedInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CHANNEL,
        value: props.get(KEYS.CHANNEL)
          ? new ChannelFeedInfoItem(this.channel)
          : null,
      },
      {
        key: KEYS.USER,
        value: props.get(KEYS.USER) ? new UserFeedInfoItem(this.user) : null,
      },
    ]);

    return selfModel as FeedInfo;
  }

  get channel(): ChannelFeedInfoItem {
    return this.get(KEYS.CHANNEL);
  }

  get user(): UserFeedInfoItem {
    return this.get(KEYS.USER);
  }

  get apiKey(): string {
    return this.get(KEYS.API_KEY);
  }
}
